import type { ICreateBulkSupraSubscriptionsBody } from '@/app-package';
import axios from 'axios';

const createBulkSupraSystemSubscriptions = async (
  body: ICreateBulkSupraSubscriptionsBody,
): Promise<{
  subscribedCount: number;
  totalCount: number;
  bulkSubscriptionUserResultMap?: Record<string, string>;
}> => {
  const { data } = await axios.post(
    '/supra_system/subscription/create_bulk',
    body,
  );
  return data;
};

export default createBulkSupraSystemSubscriptions;
